<template>
  <div id="app">
    <img :src="Image" class="banner-img" id="banner">
    <el-row class="container containbox">
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="one">
        <div class="menu">
          <img class="" src="../../../static/img/dn-36.png">
          <div :class="{'active':isActive==0}" class="menu-item" @click="ChangeActive(0)">商务合作</div>
          <div :class="{'active':isActive==1}" class="menu-item" @click="ChangeActive(1)">人才招聘</div>
        </div>
      </el-col>
      <!-- 商务合作 -->
      <el-col :xs="0" :sm="2" :md="2" :lg="2" :xl="2" class="span" v-if="isActive==0">1</el-col>
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="two" v-if="isActive==0">
        <div v-for="(item,i) in Company" :key="i">
          <div class="part-1 MediaTest2">{{item}}</div>
        </div>

        <div class="part-2-phone Regular">商务咨询：</div>
        <div class="part-2-phone-container Light" v-for="(item,i) in footer.tel" :key="i" >
          <div class="MediaTest Light" v-for="(items,ind) in item.value" :key="ind">
            <span v-if="!(i==0&&ind==0)&&!(i==0&&ind==1)" :class="{'active':ind!==0}">{{item.key}}:</span>
            <span v-if="i==0" :class="{'noshow':ind!==1}">{{item.key}}:</span>
            <span v-if="!(i==0&&ind==0)">{{items}}</span>
          </div>
        </div>
        <!-- <div class="MediaTest Light">Email：Cayla_deno@163.com</div> -->
        <div v-for="(item,i) in footer.email" :key="i">
          <div class="MediaTest Light" v-for="(items,ind) in item.value" :key="ind"><span :class="{'active':ind!==0}">{{item.key}}:</span>{{items}}</div>
        </div>
        <div v-for="(item,i) in footer.qq" :key="i">
          <div class="MediaTest Light" v-for="(items,ind) in item.value" :key="ind"><span :class="{'active':ind!==0}">{{item.key}}:</span>{{items}}</div>
        </div>
        <!-- <div class="MediaTest Light"><span style="visibility: hidden;">Email：</span>dn-design@vip.163.com</div> -->
        <!-- <div class="qrcode Light">在线客服</div> -->
        <div class="qrbox" >
          <div v-for="(item,i) in codeImg.pictureArray" :key="i" class="qritem">
            <img class="qrcode-img" :src="item">
            <p class="MarginTop10 Light">{{Test[i]}}</p>
          </div>
        </div>

        <div class="heard-phone Medium">{{footer.tel[0].value[0]}}</div>
      </el-col>
      <el-col :xs="0" :sm="2" :md="2" :lg="2" :xl="2" class="span" v-if="isActive==0">1</el-col>
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="two three" v-if="isActive==0">
        <div v-for="(item,i) in Company" :key="i" style="visibility:hidden">
          <div class="part-1">{{item}}</div>
        </div>
        <div v-for="(item,i) in footer.location" :key="i" :class="{'company':i==0}">
          <div class="part-3 Regular">{{item.key}}：</div>
          <div class="part-3-container Light">{{item.value}}</div>
        </div>
        <!-- <div class="part-3">德诺 | 上海 | </div>
        <div class="part-3-container Light">上海·松江 石湖荡镇石湖新路95号</div>
        <div class="part-3">德诺 | 伦敦 | </div>
        <div class="part-3-container Light">36 Gerrard Street,London W1D 5QA</div>
        <div class="part-3-container Light">Email：dn-design@vip.163.com</div> -->
      </el-col>
      <!-- 人才招聘 -->
      <el-col :xs="0" :sm="2" :md="2" :lg="2" :xl="2" class="span" v-if="isActive==1">1</el-col>
      <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" class="two" v-if="isActive==1">
        <!-- <div class="part-1">{{List[0]}}</div> -->
        <div v-for="(item,i) in List" :key="i" class="zhaopin">
          <div class="part-2-container Light">{{item}}</div>
        </div>
        <div class="worker">
          <div class="worker-item" v-for="(val, key) in Job" :key="key">
            <div class="name Medium">{{key}}</div>
            <div class="detail Light">{{val}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <Call></Call>
  </div>
</template>

<script>
  import Call from "../CallUs";
  export default {
    components: {
      Call
    },
    data() {
      return {
        isActive:0,
        Image: [],
        scroll: '',
        Company:[],
        List:[],
        Job:{},
        footer:{
          location:[],
          email:[],
          tel:[],
          qq:[]
        },
        codeImg:[],
        Test:[]
      }
    },
    mounted(){
      this.Init()
    },
    watch:{   //监听路由变化
      $route( to , from ){   
        this.Init()
      }
    },
    deactivated() {
      this.$destroy()
    },
    methods: {
      Init(){
        this.mainurl = mainurl
        this.getInfo()
        this.getInfo1()
        this.getInfo2()
        this.getInfo3()
        this.getInfo4()
        this.getfoot()
        // let clientWight = $("#banner").css("width");
        // console.log(clientWight)
        // // let clientWight = $('#banner').css("width");
        //   clientWight = clientWight.replace('px','')
        // document.getElementById('banner').setAttribute('style', 'height: ' + clientWight * 0.4 + 'px');
        // window.onresize = function temp() {
        //   let clientWight = $('#banner').css("width");
        //   clientWight = clientWight.replace('px','')
        //   document.getElementById('banner').setAttribute('style', 'height: ' + clientWight * 0.4 + 'px');
        // };
      },
      ChangeActive(active){
        this.isActive = active
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getInfo() {
        this.$http
          .get("deno/api/publicity/info", {
            params: {
              title: '联系我们-1',
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.Image = response.data.data.pictures;
              }
            }.bind(this)
          )
      },
      getInfo4() {
        this.$http
          .get("deno/api/publicity/info", {
            params: {
              title: '联系我们-2',
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.codeImg = response.data.data;
                var result = []
                result = this.codeImg.context1.split("，");
                for (let i = 0; i < result.length; i++){
                    this.Test.push(result[i]);
                }
              }
            }.bind(this)
          )
      },
      getInfo1(){
        this.$http
          .get("deno/api/contacts/company", {
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.Company = response.data.data
              }
            }.bind(this)
          )
      },
      getInfo2(){
        this.$http
          .get("deno/api/contacts/recruit", {
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.List = response.data.data
              }
            }.bind(this)
          )
      },
      getInfo3(){
        this.$http
          .get("deno/api/contacts/job", {
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.Job = response.data.data
              }
            }.bind(this)
          )
      },
      getfoot(){
        this.$http
          .get("deno/api/contacts/contacts", {
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                let footer = response.data.data;
                for (let i = 0; i < footer.email.length; i++) {
                  footer.email[i].value = footer.email[i].value.split(",")
                }
                for (let i = 0; i < footer.qq.length; i++) {
                  footer.qq[i].value = footer.qq[i].value.split(",")
                }
                for (let i = 0; i < footer.tel.length; i++) {
                  footer.tel[i].value = footer.tel[i].value.split(",")
                }
                console.log(footer)
                this.footer = footer
              }
            }.bind(this)
          )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.noshow
  display none
.MarginTop10
  margin-top 10px
.banner-img
  width: calc(100% - 60px);
  margin: 0 30px;
.part-1
  font-size 20px
.qrbox
  display flex
  margin-top 80px
  .qritem
    text-align center
    margin-right 20px
.heard-phone
  font-size 40px
  margin-top 40px
  margin-bottom 60px
.containbox
  font-size 16px
  margin-top 60px
  margin-bottom 30px
  .one
    line-height: 2;
    margin-bottom: 30px;
    position relative
    border-top: 2px solid #ccc;
    img
      position absolute
      left 0
      top: -18px;
      width: 30px;
    .menu-item
      cursor pointer
      color #ccc
    .menu-item.active
      color #000
  .two
    font-size 16px
    .part-2-title
      margin-bottom: 10px;
    .part-2-phone
      margin-top: 80px; 
      margin-bottom: 10px;
    .qrcode
      margin-top 30px
    .qrcode-img
      width 125px
      height 125px
    .part-3
      margin-bottom: 20px;
    .part-3-container
      margin-bottom: 40px;
  .three
    margin-bottom: 30px;
    .company
      margin-top 80px
  .span
    color raba(0,0,0,0)
    visibility hidden
  .worker
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    .worker-item
      width 33.33%
      .name
        color #ffda2a
        font-size 18px
      .detail
        padding: 20px 0 40px 0;
.zhaopin:nth-child(1) .Light
  font-family: 'Medium';
.zhaopin
  line-height 2
.MediaTest span.active
  visibility hidden
.part-1,.MediaTest
  margin-bottom 10px
.MediaTest2
  margin-bottom 20px
@media (max-width:780px) 
  .banner-img
    width: calc(100% - 10px);
    margin: 0 5px;
// 大屏
@media (min-width:1920px) 
  .newsbox .news .padding .time
    font-size 48px
  .newsbox .news .news-title,.newsbox .news .title,.newsbox .news .contain
    font-size 30px
  .containbox .worker .worker-item .name
    font-size 24px
  .banner-img
    width: calc(100% - 120px);
    margin: 0 60px;
  .containbox
    margin-top 60px
    font-size 30px
    line-height 30px
  .containbox .one .menu-item
    font-size 20px
    line-height 60px
  .containbox .one img
    width 45px
    top: -25px;
  .containbox .two
    font-size 20px
  .containbox .two .part-2-phone
    font-size 20px
  .containbox .two .qrcode-img
    width 130px
    height 130px
  .containbox .worker
    margin-top 100px
  .containbox .worker .worker-item .detail
    padding: 18px 0 50px 0;
    line-height: 2;
  .heard-phone
    font-size 50px
    margin-top 50px
    margin-bottom 120px
  .part-1
    font-size 24px
  .qrbox
    margin-top 100px
  .containbox .two .part-2-title 
    margin-top: 100px;
  .qritem
    margin-right 30px
</style>


// WEBPACK FOOTER //
// src/components/AboutUs/JoinUs.vue